import { FC } from 'react';

import targetViewButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/main_page/target_view_button_click';
import { Input, Link, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    CampaignTarget,
    selectWizardWebsiteUrl,
    selectWizardWebsiteUrlErrorKey,
    setWizardWebsiteUrl,
} from 'store/models/campaignCreationWizard';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/CampaignCreationWizard/VacancySelectStep/components/WebsiteUrlTab/WebsiteUrlTab.module.less';

const TrlKeys = {
    description: 'CampaignCreationWizard.VacancySelectStep.website.description',
    placeholder: 'CampaignCreationWizard.VacancySelectStep.website.placeholder',
    showLink: 'adCreateMenu.bannerLink.show',
};

const getCorrectLink = (link: string): string => {
    if (link.includes('http')) {
        return link;
    }
    return `http://${link}`;
};

export const WebsiteUrlTab: FC = () => {
    const dispatch = useDispatch();
    const trl = useTrls();
    const websiteUrl = useSelector(selectWizardWebsiteUrl);
    const websiteUrlErrorKey = useSelector(selectWizardWebsiteUrlErrorKey);

    const handleWebsiteUrlChange = (value: string) => {
        dispatch(setWizardWebsiteUrl(value));
    };

    return (
        <>
            <Text typography="label-1-regular" style="primary">
                {trl(TrlKeys.description)}
            </Text>
            <VSpacing default={24} />
            <div className={styles.inputContainer}>
                <Input
                    value={websiteUrl}
                    onChange={handleWebsiteUrlChange}
                    placeholder={trl(TrlKeys.placeholder)}
                    clearable
                    invalid={websiteUrlErrorKey !== null}
                    errorMessage={websiteUrlErrorKey ? trl(websiteUrlErrorKey) : undefined}
                    data-qa="ad-create-website-url"
                />
                {websiteUrl && (
                    <>
                        <VSpacing default={8} />
                        <Link
                            href={getCorrectLink(websiteUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => targetViewButtonClick({ campaignTarget: CampaignTarget.Website })}
                            data-qa="show-website-link"
                        >
                            <Text typography="label-3-regular">{trl(TrlKeys.showLink)}</Text>
                        </Link>
                    </>
                )}
            </div>
        </>
    );
};
